import { observer } from 'mobx-react-lite'
import { ReviewViewContext } from 'pages/reviews/context/reviewViewContext'
import { ReviewViewContent } from 'pages/reviews/ui/ReviewViewContent/ReviewViewContent'
import { type ReviewViewStore } from 'pages/reviews/store'

type IEditReviewViewProps = {
  store: ReviewViewStore
}

export const EditReviewView = observer(({ store }: IEditReviewViewProps) => {
  return (
    <ReviewViewContext.Provider value={store}>
      <ReviewViewContent />
    </ReviewViewContext.Provider>
  )
})
